const CloseIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 60 60"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        id="Artboard"
        transform="translate(-924.000000, -69.000000)"
        stroke="#FFFFFF"
        strokeWidth="2.25"
      >
        <g
          id="Group"
          transform="translate(924.000000, 69.000000)"
        >
          <line
            x1="22.2931034"
            y1="22.2931034"
            x2="38.7304326"
            y2="38.7304326"
            id="Line"
          />
          <line
            x1="22.2931034"
            y1="22.2931034"
            x2="38.7304326"
            y2="38.7304326"
            id="Line"
            transform="translate(30.500000, 30.500000) scale(-1, 1) translate(-30.500000, -30.500000) "
          />
        </g>
      </g>
    </g>
  </svg>
);

export default CloseIcon;
